import { PromptSelector } from '@startupquickstart/frontend';
import { useEffect, useState } from 'react';
import { AiGenerateDialog, type AiGenerateDialogProps } from './AiGenerateDialog';

type BaseProps = Omit<AiGenerateDialogProps, 'buildPayload' | 'children'>;

export interface AiGenerateWithPromptDialogProps extends BaseProps {
  /** PromptPurpose value used to filter prompt options. */
  promptPurpose: string;
  /** Optional label for the PromptSelector. */
  promptLabel?: string;
  /** Extra fields merged into the POST body alongside `{ promptId }`. */
  extraPayload?: Record<string, unknown>;
}

/**
 * Drop-in replacement for `GenerateWithPromptDialog` from the shared
 * frontend package — same UI shape, but routes through the on-demand AI-job
 * pipeline (controller returns 202, dialog tracks completion via socket).
 */
export function AiGenerateWithPromptDialog({
  promptPurpose,
  promptLabel,
  extraPayload,
  open,
  ...dialogProps
}: AiGenerateWithPromptDialogProps) {
  const [promptId, setPromptId] = useState<string | undefined>();

  useEffect(() => {
    if (open) setPromptId(undefined);
  }, [open]);

  return (
    <AiGenerateDialog
      {...dialogProps}
      open={open}
      buildPayload={() => ({ promptId, ...(extraPayload ?? {}) })}
    >
      <PromptSelector
        purpose={promptPurpose}
        value={promptId}
        onChange={setPromptId}
        label={promptLabel}
      />
    </AiGenerateDialog>
  );
}
